var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "white",
    stroke: "#262261"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 18.9062C25.3426 18.9062 23.5937 20.6551 23.5937 22.8125C23.5937 24.9699 25.3426 26.7187 27.5 26.7187C29.6574 26.7187 31.4062 24.9699 31.4062 22.8125C31.4062 20.6551 29.6574 18.9062 27.5 18.9062Z",
    fill: "#262261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 28.8021C21.176 28.8021 19.4271 30.551 19.4271 32.7083V33.9461C19.4271 34.7307 19.9957 35.3997 20.7701 35.5262C25.2272 36.2539 29.7728 36.2539 34.2299 35.5262C35.0043 35.3997 35.5729 34.7307 35.5729 33.9461V32.7083C35.5729 30.551 33.824 28.8021 31.6667 28.8021H31.3116C31.1194 28.8021 30.9284 28.8325 30.7458 28.8921L29.8442 29.1865C28.321 29.6839 26.679 29.6839 25.1558 29.1865L24.2542 28.8921C24.0716 28.8325 23.8806 28.8021 23.6884 28.8021H23.3333Z",
    fill: "#262261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.18cb6cdc9c6ed28b708c2bc4a431e03e.svg";
export { ForwardRef as ReactComponent };